import { render } from "./SoapForm.vue?vue&type=template&id=13eb250c"
import script from "./SoapForm.vue?vue&type=script&lang=js"
export * from "./SoapForm.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__